import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class MedicineTagUtilsService {

  private mainTagsCache = new WeakMap<any[], any[]>();
  private extraTagsCache = new WeakMap<any[], any[]>();
  private tooltipCache = new WeakMap<any[], string>();

  constructor() { }  
  
  sortByPriority(tags: any[]) {
    if(!tags)
      return [];
    return [...tags].sort((a, b) => {
      if (a.priority == null) return 1;
      if (b.priority == null) return -1;
      return a.priority - b.priority;
    });
  }

  getMainTags(tags: any[], limit = 3) {
    if (!tags) return [];
    if (this.mainTagsCache.has(tags)) {
      return this.mainTagsCache.get(tags);
    }
    const result = this.sortByPriority(tags).slice(0, limit);
    this.mainTagsCache.set(tags, result);
    return result;
  }

  getExtraTags(tags: any[], limit = 3) {
    if (!tags) return [];
    if (this.extraTagsCache.has(tags)) {
      return this.extraTagsCache.get(tags);
    }
    const result = this.sortByPriority(tags).slice(limit);
    this.extraTagsCache.set(tags, result);
    return result;
  }

  getTooltipText(tags: any[], limit = 3): string {
    if (!tags) return '';
    if (this.tooltipCache.has(tags)) {
      return this.tooltipCache.get(tags);
    }
    const result = this.getExtraTags(tags, limit)
      .map(tag => `• ${tag.tagName}`)
      .join('\n');
    this.tooltipCache.set(tags, result);
    return result;
  }
}